export var ScheduleRoutes = {
    "/schedule?user&openSidebar&openEfficiencyBudgetModal&date&openScheduleGraph": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.main",
        "preventTimeTracking": true,
        "type": "frontend",
        "dynamic": true,
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Schedule"
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["settings_forms_wrapper", 'breaks-management', 'gen-ai']
        },
        "resolve": {
            'pre_load': ["TeamScheduleService", "$stateParams", function (TeamScheduleService, $stateParams) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        var initialDate = moment($stateParams.date);

                        if (!initialDate.isValid()) {
                            initialDate = moment();
                        }

                        var selectedDay = Utils.getWeekStart(initialDate, brand.startDayOfWeek).format("MMM DD, YYYY");

                        TeamScheduleV2API.getBrandSchedule(brand.id, selectedDay, undefined, undefined, true);
                        TeamScheduleV2API.getBrandCrossSchedules(brand.id, selectedDay, undefined, true);
                        TeamAPI.getBrandScheduleCostsV2(brand.id, selectedDay, true);

                    });
            }]
        },
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"},
            {
                type: 'chunk',
                loader: function () {
                    return import("./schedule.module.js");
                }
            }
        ],
        "views": {
            "body": {
                componentProvider: ['deviceChecker', function (deviceChecker) {
                    if (deviceChecker.isMobile()) {
                        return 'mobileEmployerSchedulePage';
                    }
                    else {
                        return 'employerSchedulePage';
                    }
                }]
            }
        }
    },
    "/schedule-hours-and-forecasting": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.schedule-hours-and-forecasting",
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./schedule.module.js");
                }
            }
        ],
        "route_styles": {
            styles: ["settings_forms_wrapper"]
        },
        "views": {
            "body": {
                componentProvider: ['deviceChecker', function (deviceChecker) {
                    if (deviceChecker.isMobile()) {
                        return 'mobileEmployerSchedulePage';
                    }
                    else {
                        return 'employerSchedulePage';
                    }
                }]
            }
        }
    },
    "/print-schedule": {
        "loginRequired": true,
        "name": "print-schedule",
        "type": "frontend",
        "component": "printSchedulePage",
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./schedule-print.module.js");
                }
            }
        ],
        "onEnter": ['localize', function (localize) {
            localize.disableLocale();
        }]
    },
    "/schedule-dash?date": {
        "loginRequired": true,
        "showGlobalSearch": true,
        "name": "appLayout.schedule.schedule-dash",
        "views": {
            "body": {
                "component": "scheduleSubmissionsDashPage"
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
        },
        "type": "frontend",
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./schedule.module.js");
                }
            }
        ]
    }
};
